import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Menu, MenuItem, Typography, useTheme, Tooltip} from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SmartDisplayIcon from '@mui/icons-material/SmartDisplay';
import HeadsetIcon from '@mui/icons-material/Headset';

import ReactLoading from 'react-loading';

import { DeleteVoiceClone, GetVoiceCloneSubtitles, GetVoiceCloneTranslation} from "../../../../axios/ApiProvider";
import emptyThumb from "../../../../assets/image/emptyThumb.jpg";
import Swal from "sweetalert2";

export const EDIT_FRONTEND_URL = process.env.REACT_APP_BASE_FRONTEND_EDITOR_URL;

const ListView = ({ itemData, onDelete, isUploading, showModal, currentLocalPageIndex, getVoiceClones, openShareLinkModal, setAssetUUID, uploadProgress }) => {
  const languageStrs = useSelector((store) => store.editdata.languageStrs);
  const [anchorEl, setAnchorEl] = useState(null);
  const [progressValue, setProgressValue] = useState(uploadProgress ?? itemData.progress);

  const [downloadProgress, setDownloadProgress] = useState(
    () => parseFloat(localStorage.getItem(`${itemData.uuid}-progress`)) || 0
  );
  const [audioDownloadProgress, setAudioDownloadProgress] = useState(
    () => parseFloat(localStorage.getItem(`${itemData.uuid}-audio-progress`)) || 0
  );

  const [isDownloading, setIsDownloading] = useState(false);
  const [isAudioDownloading, setIsAudioDownloading] = useState(false);

  const open = Boolean(anchorEl);

  const theme = useTheme();

  const handleClickMore = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleDeleteVoiceClone = async () => {
    setAnchorEl(null);
    let result = await DeleteVoiceClone(itemData.uuid, false);
    if (result.state === "success") {
      await getVoiceClones(currentLocalPageIndex, true)
    } else {
      console.error("Error:", result.data?.message || result.data);
    }
  };

  const handleDeleteVoiceCloneWithAssets = async () => {
    setAnchorEl(null);
    let result = await DeleteVoiceClone(itemData.uuid, true);
    if (result.state === "success") {
      await getVoiceClones(currentLocalPageIndex, true)
    } else {
      console.error("Error:", result.data?.message || result.data);
    }
  };

  const handleRedub = async () => {
    setAnchorEl(null);
    await showModal(itemData);
  };

  const handleEditVoiceCloneProject =  (itemData) => {
    window.open(`${EDIT_FRONTEND_URL}/${itemData.project_uuid}`,'_blank');
    setAnchorEl(null);
  }
// useEffect(() => {
//     const syncUploadProgress = () => {
//       const savedProgress = parseFloat(localStorage.getItem(`${itemData.uuid}-upload-progress`)) || 0;
//       if (savedProgress >= 0 && savedProgress < 100) {
//         setProgressValue(savedProgress);
//       } else if (savedProgress === 100) {
//         setProgressValue(100);
//       }
//     };
  
//     if (isUploading && itemData.state === 1 && itemData.state_text === "UPLOADING") {
//       syncUploadProgress(); 
//       const intervalId = setInterval(syncUploadProgress, 1000);
//       return () => clearInterval(intervalId);
//     } else {
//       setProgressValue(itemData.progress);
//     }
    
//   }, [itemData.progress, itemData.state, isUploading]);

  useEffect(() => {
    if (typeof uploadProgress === 'number') {
      setProgressValue(uploadProgress);
    } else {
      setProgressValue(itemData.progress);
    }
  }, [uploadProgress, itemData.progress]);
  
  const calculateTimeAgo = (date) => {
    const now = new Date();
    const past = new Date(date);
    const diff = now - past;

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) return `${days} ${languageStrs.days_ago}`;
    if (hours > 0) return `${hours} ${languageStrs.hours_ago}`;
    if (minutes > 0) return `${minutes} ${languageStrs.minutes_ago}`;
    return `${seconds} ${languageStrs.seconds_ago}`;
  };

  const handleClickItem = (e) => {
    e.preventDefault();
  };

  //Modify output file name on download
  const cleanFilename = (filename) => {
    return filename.replace(/\.[^.]+$/, "");
  };

  //Handle video download
  const handleDownload = async (url, customFilename) => {
    try {
      setIsDownloading(true);
      setDownloadProgress(0);

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`);
      }

      const contentLength = response.headers.get("Content-Length");
      const total = contentLength ? parseInt(contentLength, 10) : 0;
      const reader = response.body.getReader();
      const chunks = [];
      let receivedLength = 0;

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        chunks.push(value);
        receivedLength += value.length;
        const progress = (receivedLength / total) * 100;
        setDownloadProgress(progress);
        localStorage.setItem(`${itemData.uuid}-progress`, progress);
      }

      const blob = new Blob(chunks);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = customFilename;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error during file download:", error);
    } finally {
      setIsDownloading(false);
      setDownloadProgress(0);
      localStorage.removeItem(`${itemData.uuid}-progress`);
    }
  };

  const onDownloadSubtitle = async (isTranslation) => {
    setAnchorEl(null);
    let getSubtitles;

    if (isTranslation) {
      getSubtitles = await GetVoiceCloneTranslation(itemData.uuid);
    } else {
      getSubtitles = await GetVoiceCloneSubtitles(itemData.uuid);
    }

    if (getSubtitles.state !== "success" || !getSubtitles.data?.subtitles_text) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Subtitles has not been generated yet.",
        showConfirmButton: true,
        confirmButtonText: "Ok",
      });
      return;
    }

    try {
      let subtitlesResponse = getSubtitles.data.subtitles_text;

      // Create blob and object URL
      let blob = new Blob([subtitlesResponse], { type: "text/srt;charset=utf-8" });
      let url = URL.createObjectURL(blob);

      // Create temporary link
      let a = document.createElement("a");
      a.href = url;
      a.download = isTranslation ? `${itemData.title}_${itemData.target_lang}.srt` : `${itemData.title}_${itemData.lang}.srt`
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Cleanup object URL
      URL.revokeObjectURL(url);
    } catch (err) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Error while saving subtitles.",
        text: err.message,
        showConfirmButton: true,
        confirmButtonText: "Ok",
      });
    }
  };


  useEffect(() => {
    const syncProgress = () => {
      const savedProgress = parseFloat(localStorage.getItem(`${itemData.uuid}-progress`)) || 0;
      if (savedProgress > 0 && savedProgress < 100) {
        setIsDownloading(true);
      } else {
        setIsDownloading(false);
      }
      setDownloadProgress(savedProgress);
    };
  
    syncProgress();
  
    const intervalId = setInterval(syncProgress, 1000);
  
    return () => clearInterval(intervalId);
  }, [itemData.uuid]); 


  //Handle audio download
  const handleAudioDownload = async (url, customFilename) => {
    try {
      setIsAudioDownloading(true);
      setAudioDownloadProgress(0);
  
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`);
      }
  
      const contentLength = response.headers.get("Content-Length");
      const total = contentLength ? parseInt(contentLength, 10) : 0;
      const reader = response.body.getReader();
      const chunks = [];
      let receivedLength = 0;
  
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
  
        chunks.push(value);
        receivedLength += value.length;
        const progress = (receivedLength / total) * 100;
        setAudioDownloadProgress(progress);
        localStorage.setItem(`${itemData.uuid}-audio-progress`, progress);
      }
  
      const blob = new Blob(chunks);
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = customFilename;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Error during audio download:", error);
    } finally {
      setIsAudioDownloading(false);
      setAudioDownloadProgress(0);
      localStorage.removeItem(`${itemData.uuid}-audio-progress`);
    }
  };
  
  useEffect(() => {
    const syncAudioProgress = () => {
      const savedProgress = parseFloat(localStorage.getItem(`${itemData.uuid}-audio-progress`)) || 0;
      if (savedProgress > 0 && savedProgress < 100) {
        setIsAudioDownloading(true);
      } else {
        setIsAudioDownloading(false);
      }
      setAudioDownloadProgress(savedProgress);
    };
  
    syncAudioProgress();
  
    const intervalId = setInterval(syncAudioProgress, 1000);
    return () => clearInterval(intervalId);
  }, [itemData.uuid]);
  
  return (
    <Box
      className="project-list-item"
      sx={{
      borderColor: theme.palette.mode === 'dark' 
      ? theme.palette.grey[800] + "!important" 
      : theme.palette.grey[200] + "!important",
      }}
    >
      {/* Thumbnail and Title */}
      <div onClick={handleClickItem} className="project-listItem-cell1">
        {itemData?.output_video_thumbnail_signed_url ? 
        (
          <img
            src={itemData.output_video_thumbnail_signed_url}
            alt="project-thumbnail"
            className="listItem-thumbnail"
          />
        ):
        itemData.state_text !== "SUCCESS" ? 
          <ReactLoading type={'bubbles'} color='rgb(53 126 221)' height={48} width={48} className="react-loading"/> : 
        (
          <img
            src={emptyThumb}
            alt="project-thumbnail"
            className="listItem-thumbnail"
          />
        )}
        <Box className="listItem-cell1-text title-cell">
          <Box className="listItem-cell1-header title-wrapper">
            <Tooltip title={itemData.title || "No Title"} placement="top-start">
              <Typography className="clone-title" variant="subtitle" sx={{
              color: theme.palette.mode === 'dark' 
              ? theme.palette.grey[200] 
              : theme.palette.grey[900]
              }}
              >
              {itemData.title || languageStrs.no_title}
              </Typography>
            </Tooltip>
          </Box>
        </Box>
      </div>

      <Box className="project-listItem-cell2 languages-cell" >
        <Box className="listItem-cell2-text">
          <Box className="source-target-languages">
            <Typography variant="subtitle">
              {typeof itemData.lang === "string" ? languageStrs[itemData.lang.toLowerCase()] : languageStrs.unknown }
            </Typography>
            <ArrowDropDownIcon sx={{rotate: "-90deg", width: "18px !important"}}/>
            <Typography variant="subtitle">
            {typeof itemData.target_lang === "string" ? languageStrs[itemData.target_lang.toLowerCase()] : languageStrs.unknown }
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        className="project-listItem-cell2 progress-cell"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <progress style={{ width: "50%" }} value={progressValue || 1} max="100"></progress>
        <span className="listItem-cell2-text">%{Math.min(progressValue || 0, 100)}</span>
      </Box>

      <Box className="project-listItem-cell2 clone-state">
        <div className="listItem-cell2-text">{itemData.state_text || languageStrs.unknown}</div>
      </Box>  

       <Box className="project-listItem-cell2 download-buttons">
      {itemData.output_video_signed_url ? (
        <div
          className="listItem-cell1-text"
          style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
        >
          <button
            className="download-link"
            onClick={() =>
              handleDownload(itemData.output_video_signed_url, `${cleanFilename(itemData.title)}_${itemData.target_lang}.mp4`)
            }
            disabled={isDownloading}
          >
            {isDownloading ? "" : <span>{languageStrs.watch_video} <SmartDisplayIcon className="download-icon"/></span>}
          </button>
          {isDownloading && (
            <div style={{width: "100%", marginInline: "auto"}}>
              <progress className="downloading-progress-video"  value={downloadProgress} max={100} style={{ width: "100%" }} />
              <span className="downloading-text" style={{fontSize: "9px"}}>{languageStrs.downloading} %{Math.round(downloadProgress)}</span>
            </div>
          )}
        </div>
      ) : (
        <div style={{ color: "gray" }}>{languageStrs.video_preparing}</div>
      )}
      {itemData.output_audio_signed_url ? (
          <div className="listItem-cell1-text listen-audio-mobile-btn">
           <button
        className="download-link"
        onClick={() =>
          handleAudioDownload(itemData.output_audio_signed_url, `${cleanFilename(itemData.title)}_${itemData.target_lang}.mp3`)
        }
        disabled={isAudioDownloading}
      >
        {isAudioDownloading ? "" : <span>{languageStrs.listen_audio} <HeadsetIcon className="download-icon"/></span>}
      </button>
      {isAudioDownloading && (
        <div style={{ width: "100%", marginInline: "auto" }}>
          <progress className="downloading-progress-audio" value={audioDownloadProgress} max={100} style={{ width: "100%" }} />
          <span style={{ fontSize: "9px" }}>{languageStrs.downloading} %{Math.round(audioDownloadProgress)}</span>
        </div>
      )}
          </div>
        ) : (
          <div className="listItem-cell1-text listen-audio-mobile-btn" style={{ color : "gray", display: "none"}} >Audio Preparing</div>
        )}
    </Box>

      <Box className="project-listItem-cell2 listen-audio-btn download-buttons">
        {itemData.output_audio_signed_url ? (
          <div className="listItem-cell1-text" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
           <button
        className="download-link"
        onClick={() =>
          handleAudioDownload(itemData.output_audio_signed_url, `${cleanFilename(itemData.title)}_${itemData.target_lang}.mp3`)
        }
        disabled={isAudioDownloading}
      >
        {isAudioDownloading ? "" :  <span>{languageStrs.listen_audio} <HeadsetIcon className="download-icon"/></span>}
      </button>
      {isAudioDownloading && (
        <div style={{ width: "100%", marginInline: "auto" }}>
          <progress value={audioDownloadProgress} max={100} style={{ width: "100%" }} />
          <span style={{ fontSize: "9px" }}>{languageStrs.downloading} %{Math.round(audioDownloadProgress)}</span>
        </div>
      )}
          </div>
        ) : (
          <div style={{ color : "gray" }} >{languageStrs.audio_preparing}</div>
        )}
      </Box>

      <Box className="project-listItem-cell3 date-modified">
        <span className="listItem-cell3-text">
          {calculateTimeAgo(itemData.created_at)}
        </span>
      </Box>

      <Box className="project-listItem-cell4 options" onClick={handleClickMore}>
        <MoreVertIcon />
      </Box>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleDeleteVoiceClone}>{languageStrs.delete_voice_clone}</MenuItem>
        <MenuItem onClick={handleDeleteVoiceCloneWithAssets}>{languageStrs.delete_voice_clone_assets}</MenuItem>
        <MenuItem onClick={handleRedub}>Re-Dub with Another Language</MenuItem>
        <MenuItem onClick={() => onDownloadSubtitle(false)}>Download Subtitles</MenuItem>
        <MenuItem onClick={() => onDownloadSubtitle(true)}>Download Subtitles Translation</MenuItem>
        <MenuItem
          onClick={() => {
            setAssetUUID(itemData?.output_video_asset_uuid);
            openShareLinkModal();
            setAnchorEl(null);
          }}
        >
          Share
        </MenuItem>
        <MenuItem disabled={itemData.project_uuid == null} onClick={() => handleEditVoiceCloneProject(itemData)}>Edit Project</MenuItem>
      </Menu>
    </Box>
  );
};

export default ListView;